import './App.css'
import { Content } from 'antd/es/layout/layout'
import locales from './locales/locale'
import { memo } from 'react'

export const Analcolici = ({ lang }: { lang: string }) => {
  return (
    <Content style={{ zIndex: 1 }}>
      <div
        style={{ textAlign: 'start' }}
        className="paddingTop paragrafo1 sfondoScuro noPadding "
      >
        <div>
          <h1>{locales.pagina1t1}</h1>
          <p>{locales.pagina1d1}</p>
        </div>
        {/* Photo by Ecuen Images: https://www.pexels.com/photo/close-up-of-water-pouring-in-glass-314296/ */}
        <div className="acqua" />
      </div>
      <div
        style={{ textAlign: 'start' }}
        className="paragrafo1 reverse noPadding"
      >
        <div>
          <h1>{locales.pagina1t2}</h1>
          <p>{locales.pagina1d2}</p>
        </div>
        {/* Photo by Sandu Muresan: https://www.pexels.com/photo/a-person-holding-a-can-of-soft-drink-13950097/ */}
        <div className="menta" />
      </div>
      <div
        style={{ textAlign: 'start' }}
        className="paragrafo1 sfondoScuro noPadding"
      >
        <div>
          <h1>{locales.pagina1t3}</h1>
          <p>{locales.pagina1d3}</p>
        </div>
        {/* Photo by Olena Bohovyk: https://www.pexels.com/photo/teacup-with-sliced-lemon-1772124/ */}
        <div className="tea" />
      </div>
    </Content>
  )
}

export default memo(Analcolici)
